const $$splitComponentImporter = () => import('/home/ubuntu/actix-web-dome/ui/src/apps/main/routes/_main/admin/app/request.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { AdminAppRequestFilterParamSchema } from '@apps/main/features/admin/pages/app/request-schema';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_main/admin/app/request')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: AdminAppRequestFilterParamSchema
});